/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BabylonTrxMoreDetailInfo } from './BabylonTrxMoreDetailInfo';

export type BabylonTrxDetailInfo = {
    COSMOSTRXHA: string;
    STAT: BabylonTrxDetailInfo.STAT;
    BHT: string;
    TRFAMT: string;
    TRFVAL: string;
    TRXF: string;
    TRXFVAL: string;
    GU: string;
    GUP: string;
    GW: string;
    MEMO: string;
    ISBTCSTKTRX: BabylonTrxDetailInfo.ISBTCSTKTRX;
    TRXMD: BabylonTrxMoreDetailInfo;
    AG: string;
    UT: number;
};

export namespace BabylonTrxDetailInfo {

    export enum STAT {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }

    export enum ISBTCSTKTRX {
        Y = 'Y',
        N = 'N',
    }


}

